import { IconProps } from '@tamagui/helpers-icon';
import { Center } from '@unistocks/components/layout/center';
import { Paragraph } from '@unistocks/components/text/text';
import { t } from '@unistocks/shared/localization/index.ts';
import React from 'react';
import { FontSizeTokens, ThemeableStackProps } from 'tamagui';

export type NoDataProps = ThemeableStackProps & {
  Icon?: React.ComponentType<IconProps>;
  color?: IconProps['color'];
  text?: string;
  size?: FontSizeTokens;
};

export const NoData: React.FC<NoDataProps> = ({
  Icon,
  color = '$headingFont',
  text = t('::NoDataAvailableInDatatable'),
  size = '$4',
  ...viewProps
}) => {
  return (
    <Center transition={'medium'} {...viewProps}>
      {Icon ? <Icon size={size} color={color} /> : null}
      {text ? (
        <Paragraph size={size} mt={'$3'} textAlign="center">
          {text}
        </Paragraph>
      ) : null}
    </Center>
  );
};

NoData.displayName = 'NoData';
